module.exports = __webpack_public_path__ + "media/GameOver.1ffc0902.mp3";